"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPage = void 0;
const react_1 = __importStar(require("react"));
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const MapButtons_1 = require("../../components/molecules/MapButtons/MapButtons");
const Map_1 = require("../../components/organisms/Map/Map");
const CookieBanner_1 = require("../../components/organisms/Modals/CookieBanner/CookieBanner");
const CookieSettingsModal_1 = require("../../components/organisms/Modals/CookieSettingsModal/CookieSettingsModal");
const focusTabController_1 = require("../../utils/focusTabController");
const useScreenSizeDetection_1 = __importDefault(require("../../utils/useScreenSizeDetection"));
const SurveyBanner = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("../../components/organisms/Modals/SurveyBanner/SurveyBanner"))).then((m) => ({ default: m.SurveyBanner })));
const InfoBanner = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("../../components/organisms/Modals/InfoBanner/InfoBanner"))).then((m) => ({ default: m.InfoBanner })));
const googleMapsApiKey = process.env.GOOGLE_MAPS_API_KEY || "";
const MapPage = ({ children }) => {
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const [cookieSettingsModalOpen, setCookieSettingsModalOpen] = (0, react_1.useState)(false);
    const handleOpenCookieSettings = () => {
        setCookieSettingsModalOpen(true);
    };
    const handleCloseCookieSettings = () => {
        setCookieSettingsModalOpen(false);
    };
    return (react_1.default.createElement(react_google_maps_1.APIProvider, { apiKey: googleMapsApiKey, libraries: ["places"], onLoad: () => console.log("Maps API has loaded.") },
        children,
        !isMobile && react_1.default.createElement(MapButtons_1.MapButtons, null),
        react_1.default.createElement(focusTabController_1.FocusTabController, null),
        react_1.default.createElement(Map_1.Map, null),
        react_1.default.createElement(CookieBanner_1.CookieBanner, { onOpenCookieSettings: handleOpenCookieSettings }),
        react_1.default.createElement(CookieSettingsModal_1.CookieSettingsModal, { isOpen: cookieSettingsModalOpen, onClose: handleCloseCookieSettings }),
        react_1.default.createElement(react_1.Suspense, { fallback: null },
            react_1.default.createElement(SurveyBanner, null)),
        !isMobile && (react_1.default.createElement(react_1.Suspense, { fallback: null },
            react_1.default.createElement(InfoBanner, null)))));
};
exports.MapPage = MapPage;
